module.exports = __webpack_public_path__ + "static/media/Badge_SvgFormationCoin_Gold_disabled.371cb3a4.svg";